
























































































































































































































































































































































































































































import ApprovalCard from '@/modules/_components/ApprovalCard.vue';
import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { CodeManagementDto } from '@/services/init/dto';

import {
  AdminDto,
  AdminListDto,
  CompanyDto,
  CompanyUpdateDto,
  CompanyUpdateRefusalDto,
  CompanyDistrictListDto,
  CompanyDistrictDto,
  CompanyUpdateRefusalReasonDto,
} from '@/dto';
import { Pagination, YN, CONST_YN } from '@/common';
import { BaseUser } from '@/services/shared/auth';
import BaseCard from '../../_components/BaseCard.vue';
import CompanyDetailDistrictList from './CompanyDetailDistrictList.vue';
import CompanyDetailCompanyUserList from './CompanyDetailCompanyUserList.vue';

import AdminService from '@/services/admin.service';
import CompanyService from '@/services/company.service';
import {
  APPROVAL_STATUS,
  COMPANY,
  CONST_APPROVAL_STATUS,
  CONST_COMPANY,
} from '@/services/shared';
import toast from '../../../../resources/assets/js/services/toast.js';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '@/services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '@/services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import { getStatusColor } from '@/core/utils/status-color.util';
import CodeManagementService from '@/services/code-management.service';

@Component({
  name: 'CompanyDetail',
  components: {
    ApprovalCard,
    BaseCard,
    CompanyDetailDistrictList,
    CompanyDetailCompanyUserList,
  },
})
export default class CompanyDetail extends BaseComponent {
  private adminList: AdminDto[] = [];
  private adminListDto = new AdminListDto();
  private adminListCount = null;
  private approvalStatusSelect: CodeManagementDto[] = [];

  private companyDto = new CompanyDto();
  private companyUpdateDto = new CompanyUpdateDto();
  private companyUpdateRefusalDto = new CompanyUpdateRefusalDto();
  private companyUpdateRefusalReasonDto = (this.companyUpdateRefusalDto.refusalReasons = new CompanyUpdateRefusalReasonDto());
  private pagination = new Pagination();
  private paginationAdmin = new Pagination();
  private selectedAdmin: AdminDto = new AdminDto(BaseUser);
  private newLogo: FileAttachmentDto[] = [];
  private logoChanged = false;
  private deleteCompanyName = null;
  private companyTypes: COMPANY[] = [...CONST_COMPANY];

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  // find company detail
  findOne(id) {
    CompanyService.findOne(id).subscribe(res => {
      this.companyDto = res.data;
    });
  }

  findAdmin(isPagination: boolean) {
    if (!isPagination) {
      this.paginationAdmin.page = 1;
    }
    this.paginationAdmin.limit = 5;
    AdminService.findAll(this.adminListDto, this.paginationAdmin).subscribe(
      res => {
        this.adminList = res.data.items;
        this.adminListCount = res.data.totalCount;
      },
    );
  }

  findApprovalStatus() {
    CodeManagementService.findAnyCode('APPROVAL_STATUS').subscribe(res => {
      this.approvalStatusSelect = res.data;
    });
  }

  showUpdateModal() {
    this.companyUpdateDto = this.companyDto;
    this.findOne(this.$route.params.id);
  }

  updateCompany() {
    if (this.selectedAdmin) {
      this.companyUpdateDto.managerNo = this.selectedAdmin.no;
    }
    if (this.newLogo.length > 0) {
      this.companyUpdateDto.logo = this.newLogo;
    } else {
      delete this.companyUpdateDto.logo;
    }

    CompanyService.update(
      this.$route.params.id,
      this.companyUpdateDto,
    ).subscribe(res => {
      if (res) {
        this.companyUpdateDto = new CompanyUpdateDto();
        this.findOne(this.$route.params.id);
        toast.success('수정완료');
      }
    });
  }

  // 삭제
  deleteCompany() {
    if (this.deleteCompanyName === this.companyDto.nameKr) {
      CompanyService.deleteCompany(this.$route.params.id).subscribe(res => {
        if (res) {
          this.$router.push('/company');
          toast.success('삭제완료');
        }
      });
    } else {
      toast.error('업체명을 정확히 입력해주세요');
    }
  }

  // 승인
  updateApproval() {
    CompanyService.updateCompanyStatus(
      this.$route.params.id,
      'approve-update',
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('승인완료');
      }
    });
  }

  // 거절
  updateRefusal() {
    CompanyService.updateCompanyStatus(
      this.$route.params.id,
      'refuse-update',
      this.companyUpdateRefusalDto,
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('승인거절');
      }
    });
  }

  // upload company logo
  async upload(file: File) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.COMPANY_LOGO,
      [file],
    );
    this.newLogo = [];
    this.newLogo.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
    this.logoChanged = true;
  }

  // remove company logo
  removeCompanyLogo() {
    this.$refs['fileInput'].reset();
    this.logoChanged = false;
  }

  paginateSearch() {
    this.findAdmin(true);
  }

  selectAdmin(admin: AdminDto) {
    this.selectedAdmin = admin;
  }

  cancelSelection() {
    this.selectedAdmin = new AdminDto(BaseUser);
    this.logoChanged = false;
  }

  created() {
    const id = this.$route.params.id;
    this.findApprovalStatus();
    this.findOne(id);
  }
}
